import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/contexts/AuthContext";
import { LangProvider } from "@/contexts/LangContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Programs from "@/pages/Programs";
import Settings from "@/pages/Settings";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Scanner from "@/pages/Scanner";
import AutoTrade from "@/pages/AutoTrade";
import Performance from "@/pages/Performance";
import PayPalReturn from "@/pages/PayPalReturn";
import Compliance from "@/pages/Compliance";

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/performance" element={<Performance />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/scanner" element={<ProtectedRoute><Scanner /></ProtectedRoute>} />
              <Route path="/autotrade" element={<ProtectedRoute><AutoTrade /></ProtectedRoute>} />
              <Route path="/programs" element={<ProtectedRoute><Programs /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
              <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
              <Route path="/payment/paypal/return" element={<ProtectedRoute><PayPalReturn /></ProtectedRoute>} />
              <Route path="/compliance" element={<Compliance />} />
            </Routes>
          </Layout>
          <Toaster theme="dark" position="top-right" toastOptions={{
            style: { background: "#0A0A0A", border: "1px solid #222", color: "#fff", borderRadius: "0" },
          }} />
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
